export const SURVEY_EXCLUDED_ROUTE_PREFIXES: readonly string[] = [
  '/login',
  '/logout',
  '/link_expired',
  '/record-request',
  '/form-request',
  '/request-refund',
];

export function isSurveyExcludedRoute(pathname: string | undefined | null): boolean {
  if (!pathname) return false;
  const path = pathname.split('?')[0].split('#')[0];
  return SURVEY_EXCLUDED_ROUTE_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}
